import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import "tailwindcss/tailwind.css";

import { PERSONALITY_TEST_ASSESSMENT_ID } from "../../utils/general-config";
import PathHelper from "../../utils/path-helper";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";

function DisclaimerPopup({ isVisible, setIsVisible, handleTestClick, t }) {
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const quizPath = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
  // const [isVisible, setIsVisible] = useState(false);

  const handleDismiss = () => {
    setIsVisible(false);
  };
  const navigate = useNavigate();

  return (
    <div className="p-6 sm:p-10">
      <div className="flex flex-col lg:flex-row gap-8">
        <div className="w-full">
          {isVisible && (
            <div
              id="alert-additional-content-1"
              className="p-4 mb-4 text-blue-800 border border-blue-300 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400 dark:border-blue-800"
              role="alert"
            >
              <div className="flex items-center">
                <svg
                  className="flex-shrink-0 w-4 h-4 me-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
                </svg>
                <span className="sr-only">Info</span>
                <h3 className="text-lg font-medium">
                  {t("report.career_test.please_note")}
                </h3>
              </div>
              <div className="mt-2 mb-4 text-sm">
                {t("report.career_test.personality_insights_disclaimer")}
              </div>
              <div className="flex">
                <button
                  type="button"
                  className="text-white bg-blue-800 hover:bg-blue-900 focus:ring-4 focus:outline-none focus:ring-blue-200 font-medium rounded-lg text-xs px-3 py-1.5 me-2 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  onClick={() => {
                    handleDismiss();
                    handleTestClick();
                    navigate(
                      `${quizPath.next}?assessmentId=${PERSONALITY_TEST_ASSESSMENT_ID}&newt=true`
                    );
                  }}
                >
                  {t("report.career_test.take_test_cta")}
                </button>
                <button
                  type="button"
                  onClick={handleDismiss}
                  className="text-blue-800 bg-transparent border border-blue-800 hover:bg-blue-900 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-200 font-medium rounded-lg text-xs px-3 py-1.5 text-center dark:hover:bg-blue-600 dark:border-blue-600 dark:text-blue-400 dark:hover:text-white dark:focus:ring-blue-800"
                  aria-label="Close"
                >
                  {t("report.career_test.dismiss")}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DisclaimerPopup;
